export const API_STATUS = { SUCCESS_CODE: [200, 201] };
export const MESSAGES = {
  ERROR_MESSAGE: "Something went wrong! Please try again..",
  SUCCESS_MESSAGE: "Successfully done",
};
export const GALLERY_TYPES = [
  {
    key: "landscape",
    label: "Landscape",
    desc:
      "Dhaam Farms are located amidst nature and all its bounty. The farms are in Chhudani Village of District Jhajjar, Village Malikpur and Dhansa near Delhi Haryana Border.\n" +
      "The land is very fertile as it is close to a water source which provides water for irrigation \n" +
      "throughout the year. We have retained the soil quality as there is no spray of \n" +
      "chemical pesticides or fertilisers or any other chemical activity. \n" +
      "Animals roam about freely near our farms.\n" +
      "We feel sanctified to be surrounded by such vast panorama of nature.",
  },
  {
    key: "team",
    label: "Team",
    desc:
      "Our farms are our Joy and Pride as these provide not only the food and nutrition to many people but these are also source of employment for numerous persons on the farms. All the women on the farms are also involved with the various aspects of labor like spice grinding, flour grinding, making pickles and laddoos. Our cattle are also taken care of by people of the village thereby creating employment opportunity for all. \n" +
      "The delivery persons who deliver our products to your doorstep are like angles with wings as they take Dhaam products to every nook and corner.",
  },
  {
    key: "training-expansion",
    label: "Training and Expansion",
    desc: "",
    points: [
      "INDIAN AGRICULTURAL RESEARCH INSTITUTE, PUSA, NEW DELHI",
        "\n" +
        "(IARI) is the leading institution for agricultural research, education and extension in the country. \n" +
        "We get the knowledge of Organic Farming and all the technical matters related to it from Pusa Institute. Organic Farming related issues are all resolved through training in this renowned institute.\n" +
        "\n",
      "KRISHI VIGYAN KENDRA, UJWA, NEW DELHI \n",
        "\n" +
        "Krishi Vigyan Kendra is an integral part of the National Agricultural Research System (NARS). \n" +
        "It aims at assessment of location specific technology modules in agriculture. \n" +
        "\n" +
        "KVKs have been functioning as Knowledge and Resource Centres of agriculture technology for improving the agricultural economy of the district and helping farmers like us \n" +
        "in training them for testing of soil samples.\n" +
        "This training is mandatory as it helps to maintain fertility of soil without addition of chemicals. It gives immense pleasure to us in sharing with everyone that taking into account our contribution in ORGANIC FARMING, we have been designated as Convenor in the area for all other farmers.\n" +
        "\n",
      "CENTRE OF EXCELLENCE FOR VEGETABLES (An Indo-Israel Project), Gharaunda, Haryana \n",
        "\n" +
        "This institute provides guidance for selection of good quality seeds. Knowing about the seeds and then procuring them is an essential part of good crop. \n" +
        "There are new formulas and techniques to make the production of vegetables better in every condition and weather. This training is obtained from the Indo Israel Institute.",
    ],
  },
  {
    key: "events",
    label: "Events",
    desc:
      "At Dhaam we try to involve all people from the laborers of farm to our customers in the process of farming. \n" +
      "For this purpose, we have an event of Annual picnic to the Dhaam Farms. This affair is open for all and is enjoyed by all age groups. \n" +
      "It gives opportunity to people to connect with soil and enjoy farming themselves. They like to be involved in all processes during their visit. Kids particularly enjoy watching cows and \n" +
      "buffaloes on our dairy farms.\n" +
      "We serve Desi food prepared by us to all the visitors which they particularly relish as it \n" +
      "gives the taste and flavor of nature. People from Delhi and Gurugram have been to \n" +
      "farms for such entertaining and educational visits.\n" +
      "Our farms are open throughout the year if anyone wants to visit and enjoy the flavor of Rural Life",
  },
  {
    key: "showcase",
    label: "Showcase",
    desc:
      "Dhaam Organic has been a proud and honoured participant in many demonstrations in\n" +
      "Delhi NCR region. We try to make people aware of benefits of consuming Organic Food grown without the use of any chemicals. Hence, we get appreciation from one and all.\n" +
      "We have participated in various celebrations conducted by Dwarka Mom's Facebook community at Radisson Blu, Pacific Mall and Vegas Mall. \n" +
      "In Gurugram our participation has been in residential societies of Gurugram, naming few Mahindra Aura, Belvedere Tower, The Villas. We have also showcased our products at Max Hospital, Gurugram, \n" +
      "Arya Samaj Mandir, DLF phase 1, Gurugram. \n" +
      "Recently we have collaborated with Noida Mom's Facebook community and sponsored the event at Radon, Noida.\n" +
      "Our products are hugely admired and procured by people attending these exhibitions. People like the products as they are natural and nutritious too.",
  },
];
